<template>
  <button
    :class="['button-font-style', `button-${variant}-local`, `button-${size}-local`, { 'pill-button': pill, 'w-100': block, 'button-secondary-padding': secondaryPadding }]"
    :style="{'--disabled-link-color': `var(${disabledLinkColor})`}"
    @click.stop="onClick()"
    :disabled="isDisabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'ButtonAtom',
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['small', 'medium', 'large', 'extra-large'].indexOf(value) !== -1
    },
    to: String,
    href: String,
    target: String,
    isDisabled: {
      type: Boolean,
      default: false
    },
    pill: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    disabledLinkColor: {
      type: String,
      default: '--disable-color'
    },
    secondaryPadding: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClick () {
      let routeData = this.target && this.target === '_blank'
        ? this.$router.resolve({ path: this.to })
        : null

      switch (true) {
        case !!this.to && !routeData:
          this.$router.push(this.to)
          break

        case !!this.href || !!routeData:
          window.open(routeData?.href || this.href, '_blank')
          break

        default:
          this.$emit('onClick')
          break
      }
    }
  }
}
</script>

<style>
.button-font-style {
  font-family: "Inter", sans-serif !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0px;
  text-align: center;
  min-height: 36px;
}

/* primary button style */
.button-primary-local {
  background: var(--color-royal-navy-500);
  border: 1px solid var(--color-royal-navy-500);
  box-sizing: border-box;
  border-radius: 48px;
  padding: 10px 16px;
  color: var(--color-background-white);
  transition: 0.3s;
}

.button-primary-local:hover:enabled {
  background: var(--color-royal-navy-600);
  border: 1px solid var(--color-royal-navy-600);
}

/* secondary button style */
.button-secondary-local {
  border-radius: 48px;
  background: #FFFFFF;
  border: 1px solid var(--color-royal-navy-500);
  color: var(--color-royal-navy-500);
  transition: 0.3s;
}

.button-secondary-padding {
  padding: 10px 16px;
}

.button-secondary-local:hover:enabled {
  background: var(--color-ui-element-blue-2);
  color: var(--color-background-white);
}

/* optional button style */
.button-optional-local {
  background: var(--color-ui-element-yellow-2);
  border: 1px solid var(--color-ui-element-yellow-2);
  color: var(--color-background-white);
  box-sizing: border-box;
  border-radius: 5px;
  padding: 10px 16px;
  font-weight: 600;
  /* filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.1)); */
  transition: 0.3s;
}

.button-optional-local:hover:enabled {
  background: var(--color-background-white);
  color: var(--color-ui-element-yellow-2);
}

/* link button style */
.button-link-local {
  background: none;
  outline: none;
  border: none;
  padding: 0;
  color: var(--color-ui-element-blue-2);
}

.button-link-local:hover:enabled {
  text-decoration: underline;
  cursor: pointer;
}

.button-link-local:disabled {
  color: var(--color-text-placeholder);
}

/* disabled button style */
.button-secondary-local:disabled, .button-primary-local:disabled, .button-optional-local:disabled {
  border: 1px solid var(--disable-color);
  color: var(--color-ui-text-placeholder);
  background: var(--disable-color);
}

/* pill button style */
.pill-button {
  border-radius: 48px !important;
}

/** sizes variant, copied from design system,
for style compatibility with existing component */
.button-small-local {
  min-height: 36px;
}
.button-medium-local {
  min-height: 44px;
}
.button-large-local {
  min-height: 48px;
}
.button-extra-large-local {
  min-height: 48px;
}
</style>
